import request from '@/utils/request'


// 查询用户血压测量记录列表
export function listBlood(query) {
  return request({
    url: '/joe/user-blood/list',
    method: 'get',
    params: query
  })
}

// 查询用户血压测量记录分页
export function pageBlood(query) {
  return request({
    url: '/joe/user-blood/page',
    method: 'get',
    params: query
  })
}

// 查询用户血压测量记录详细
export function getBlood(data) {
  return request({
    url: '/joe/user-blood/detail',
    method: 'get',
    params: data
  })
}

// 新增用户血压测量记录
export function addBlood(data) {
  return request({
    url: '/joe/user-blood/add',
    method: 'post',
    data: data
  })
}

// 修改用户血压测量记录
export function updateBlood(data) {
  return request({
    url: '/joe/user-blood/edit',
    method: 'post',
    data: data
  })
}

// 删除用户血压测量记录
export function delBlood(data) {
  return request({
    url: '/joe/user-blood/delete',
    method: 'post',
    data: data
  })
}
